import './Education.css';
import COLLEGE from '../COLLEGE.jpg';
import SHS from '../SHS.webp';
import HIGHSCHOOL from '../HIGHSCHOOL.jpeg';
import ELEM from '../ELEM.jpeg';

function Education() {
  const currentSchool = {
    school: 'FAITH Colleges',
    program: 'Bachelor of Science in Computer Engineering',
    yearLevel: '3rd Year College',
    duration: '2023 - Present',
    focus: 'Hardware & Software Systems',
    status: 'Currently Enrolled',
    image: COLLEGE,
    achievements: "Dean's Lister (2024–2026) | President's Lister (2023)"
  };

  const previousSchools = [
    {
      school: 'FAITH Fidelis Senior High',
      program: 'STEM Strand',
      gradeLevel: 'Grade 11 & 12',
      duration: '2021 - 2023',
      image: SHS,
      achievements: "Graduated With Honors"
    },
    {
      school: 'San Pedro National High',
      program: 'Junior High School',
      gradeLevel: 'Grade 7 - 10',
      duration: '2017 - 2021',
      image: HIGHSCHOOL,
      achievements: "Graduated With Honors"
    },
    {
      school: 'Sto. Tomas North Central',
      program: 'Elementary',
      gradeLevel: 'Grade 1 - 6',
      duration: '2011 - 2017',
      image: ELEM,
      achievements: "Graduated With Honors"
    }
  ];

  const courses = [
    'Data Structures & Algorithms',
    'Object-Oriented Programming',
    'Digital Systems Design',
    'Web Development',
    'Embedded Systems',
    'HDL / Verilog',
    'Signal Processing (DSP)',
    'Circuit Design & PCB',
    'Discrete Mathematics'
  ];

  const interests = [
    'Software Development',
    'Embedded Systems Engineering',
    'Digital Design & Microcontrollers',
    'Internet of Things (IoT)'
  ];

  return (
    <section id="education" className="education">
      <div className="education-container">
        <h2 className="section-title">Educational Background</h2>

        {/* HERO SECTION FOR CURRENT SCHOOL */}
        <div className="current-school-hero">
          <div className="hero-image-wrapper">
            <img src={currentSchool.image} alt={currentSchool.school} className="hero-image" />
            <div className="hero-status-tag">{currentSchool.status}</div>
          </div>
          
          <div className="hero-content">
            <h5 className="hero-subtitle">CURRENT PURSUIT</h5>
            <h3 className="hero-title">{currentSchool.school}</h3>
            <h4 className="hero-program">{currentSchool.program}</h4>
            
            <div className="hero-meta-grid">
              <div className="hero-meta-item">
                <span className="hero-meta-label">Year Level</span>
                <span className="hero-meta-value">{currentSchool.yearLevel}</span>
              </div>
              <div className="hero-meta-item">
                <span className="hero-meta-label">Timeline</span>
                <span className="hero-meta-value">{currentSchool.duration}</span>
              </div>
              <div className="hero-meta-item">
                <span className="hero-meta-label">Academic Focus</span>
                <span className="hero-meta-value">{currentSchool.focus}</span>
              </div>
            </div>

            <div className="hero-achievements">
              <span className="hero-achieve-icon">🏆</span>
              <span className="hero-achieve-text">{currentSchool.achievements}</span>
            </div>
          </div>
        </div>

        {/* PREVIOUS SCHOOLS GRID */}
        <div className="previous-schools-wrapper">
          <h3 className="sub-section-title">Previous Education</h3>
          <div className="previous-schools-grid">
            {previousSchools.map((school, index) => (
              <div key={index} className="prev-school-card">
                <div className="prev-img-container">
                  <img src={school.image} alt={school.school} className="prev-img" />
                  <div className="prev-overlay">
                    <span className="prev-duration">{school.duration}</span>
                  </div>
                </div>
                <div className="prev-details">
                  <h4 className="prev-school-name">{school.school}</h4>
                  <p className="prev-program">{school.program}</p>
                  <div className="prev-grade-badge">
                    <span>Grade Level:</span> {school.gradeLevel}
                  </div>
                  <p className="prev-achieve">{school.achievements}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ISOLATED RELEVANT COURSEWORK SECTION */}
        <div className="separated-section coursework-section">
          <h3 className="separated-title">Relevant Coursework</h3>
          <div className="coursework-cards-grid">
            {courses.map((course, index) => (
              <div key={index} className="course-card-v2">
                <div className="course-card-accent"></div>
                <span className="course-card-text">{course}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ISOLATED SPECIALIZATION INTERESTS SECTION */}
        <div className="separated-section interests-section">
          <h3 className="separated-title">Specialization Interests</h3>
          <div className="interests-cards-row">
            {interests.map((interest, index) => (
              <div key={index} className="interest-card-v2">
                <div className="interest-icon-circle">
                  ✦
                </div>
                <span className="interest-card-text">{interest}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default Education;
